import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="w-full bg-[#e6e3dc] text-center py-3 shadow-inner font-[Messina Sans]">
      <p className="text-xs text-[#6a7885]">
        All information contained herein is Lam proprietary information.
        © 2025 Lam Research Corporation. All rights reserved.
        {'\u00A0\u00A0'}
        <a
          href="https://www.lamresearch.com/terms/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-bold text-[#188167] hover:underline"
        >
          Terms of Use
        </a>
        {'\u00A0 and \u00A0'}
        <a
          href="https://www.lamresearch.com/privacy/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-bold text-[#188167] hover:underline"
        >
          Privacy Statement
        </a>
      </p>
    </footer>
  );
};

export default Footer;